var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d1b849169745e0ffd9c352eaac721b91.svg#c';
                    var viewUrl = 'sprites.d1b849169745e0ffd9c352eaac721b91.svg#view-c';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };